import { __assign } from "tslib";
import { AsyncState, IAction, IAsyncState } from "../action";
import { actionTypes } from "../actions";
var initialState = new AsyncState();
export function compatibility(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadDataModelNames:
        case actionTypes.loadDataModelNodes:
            return initialState;
        case actionTypes.selectOption:
        case actionTypes.unselectOption:
            return __assign(__assign({}, state), { isFetching: true, timestamp: new Date() });
        case actionTypes.compatibilityChecked:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}
